import Cookies from 'js-cookie'

const TokenKey = process.env === 'development' ? 'local' : process.env.VUE_APP_BASE_KEY

const host = location.host
const arr = host.split('.')
const domain = `.${arr[arr.length - 2]}.${arr[arr.length - 1]}`

export function getToken() {
	return Cookies.get(TokenKey)
}

export function setToken(token) {
	if (host.includes('jryghq')) {
		Cookies.set('MIS_DCMS_USER_TOKEN', token, { domain: domain })
		Cookies.set(TokenKey, token, { domain: domain })
		return
	} else {
		Cookies.set('MIS_DCMS_USER_TOKEN', token)
		Cookies.set(TokenKey, token)
		return
	}
}

export function removeToken() {
	Cookies.remove(TokenKey, { domain: domain })
	Cookies.remove(TokenKey)
	Cookies.remove('MIS_DCMS_USER_TOKEN',  { domain: domain })
	Cookies.remove('MIS_DCMS_USER_TOKEN')
}
